import { useQuery } from "@tanstack/react-query";
import { soundsApi } from "@/lib/soundsApi";

export const SERVER_SOUNDS_KEY = ["alert-sounds"] as const;

/** The sound files of the server's folder, all of them: published ones fill the pickers, drafts wait to
 * be published (docs/alert_sounds.md). */
export function useServerSounds() {
  return useQuery({
    queryKey: SERVER_SOUNDS_KEY,
    queryFn: soundsApi.list,
    staleTime: 30_000,
  });
}
